import BaseClass from "../BaseClass";
import {PushSubscription} from "./PushSubscription.js";

export class PushSubscriptionModalHandler extends BaseClass
{
    constructor(element) {
        super(element);

        this.acceptListener = null;
        this.declineListener = null;
        this.$acceptButton = null;
        this.$declineButton = null;
        this.dismissListener = null;
        this.$dismissButton = null;
        this.state = null;

        this.pushSubscription = null;

        this.init();
    }

    init()
    {
        this.pushSubscription = new PushSubscription();
        const mySelf = this;

        this.acceptListener = async function () {
            if (mySelf.state != null) {
                return;
            }

            // Setze den State, damit der User nicht beide Buttons verwenden kann
            mySelf.state = 'accepted';
            
            // Frage die Erlaubnis zum senden von Push-Notifications an
            await mySelf.pushSubscription.askForNotificationPermission();

            // Schließe danach alle Modals
            mySelf.closeallmodals();
        }

        this.declineListener = async function () {
            if (mySelf.state != null) {
                return;
            }

            // Setze den State, damit der User nicht beide Buttons verwenden kann
            mySelf.state = 'declined';

            // Setze den Zeitstempel im localStorage
            await mySelf.pushSubscription.pushNotificationsDeclined();

            // Schließe danach alle Modals
            mySelf.closeallmodals();
        }

        this.dismissListener = async function () {
            if (mySelf.state != null) {
                return;
            }

            // Setze den State, damit der User die Funktion auf dem Button nicht mehrfach auslösen kann
            mySelf.state = 'dismissed';

            // Setze den Zeitstempel im localStorage
            await mySelf.pushSubscription.iosInfoDismissed();

            // Schließe danach alle Modals
            mySelf.closeallmodals();
        }

        // Defining the accept button
        let $acceptButton = this.$element.find('[data-type="accept"]');
        if ($acceptButton !== undefined) {
            this.$acceptButton = $acceptButton;
            this.$acceptButton.on("click", this.acceptListener);
        }

        // Defining the decline button
        let $declineButton = this.$element.find('[data-type="decline"]');
        if ($declineButton !== undefined) {
            this.$declineButton = $declineButton;
            this.$declineButton.on("click", this.declineListener);
        }

        // Define the dismiss button
        let $dismissButton = this.$element.find('[data-type="dismiss-info"]');
        if ($dismissButton !== undefined) {
            this.$dismissButton = $dismissButton;
            this.$dismissButton.on("click", this.dismissListener);
        }
    }

    destroyListener() {
        this.$element.off('click', $.proxy(this.acceptListener, this));
        this.$element.off('click', $.proxy(this.declineListener, this));
        this.$element.off('click', $.proxy(this.dismissListener, this));
    }
}